import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import queryString from 'query-string';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { generateSearchUrl } from '../../../shared/helpers/urls';
import s from './PopularMarksModels.css';

import Column from './Column/Column';
import { compareByTitle } from '../../../shared/helpers/arrays';

class PopularMarksModels extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        slug: PropTypes.string,
        id: PropTypes.string.number,
        count: PropTypes.number,
      }),
    ).isRequired,
    transportType: PropTypes.shape().isRequired,
    columnsNum: PropTypes.number,
    make: PropTypes.shape(),
    isNew: PropTypes.number,
    location: PropTypes.shape(),
    onCollapseClick: PropTypes.func.isRequired,
    collapseBtnText: PropTypes.string,
    linkPrefix: PropTypes.string,
    category: PropTypes.shape(),
    collapsed: PropTypes.bool.isRequired,
    maxLinkCount: PropTypes.number.isRequired,
    lensEvent: PropTypes.string.isRequired,
  };

  static defaultProps = {
    columnsNum: 3,
    make: {},
    isNew: 0,
    location: null,
    collapseBtnText: null,
    query: null,
    linkPrefix: null,
    category: null,
  };

  onCollapseClick = () => {
    this.props.onCollapseClick();
  };

  render() {
    const {
      items,
      columnsNum,
      transportType,
      make,
      category,
      isNew,
      location,
      collapseBtnText,
      collapsed,
      maxLinkCount,
      lensEvent,
    } = this.props;
    const columnWidth = {
      width: `${100 / columnsNum}%`,
    };

    const activeItemsCount = collapsed ? items.length : maxLinkCount;
    const columns = Array.from(new Array(columnsNum), (x, i) => i);
    const step = Math.ceil(activeItemsCount / columnsNum);
    const linkPrefix =
      this.props.linkPrefix ||
      generateSearchUrl({
        make,
        ...{ isNew },
        ...{ transport: transportType },
      });
    const hiddenItems = items.filter(i => i.displayNone);
    const keyPostfix = (items.length && items[0].id) || '';
    return (
      <div className={s.root}>
        {columns.map((item, i) =>
          <Column
            key={`${item}-${keyPostfix}`}
            style={columnWidth}
            linkPrefix={linkPrefix}
            category={category}
            location={location}
            onCollapseClick={this.onCollapseClick}
            isLast={item !== columnsNum - 1}
            collapseBtnText={collapseBtnText || undefined}
            lensEvent={lensEvent}
            items={[
              ...items
                .sort(compareByTitle)
                .filter(val => !val.displayNone)
                .slice(i * step, (i + 1) * step),
              ...(i + 1 === columnsNum ? hiddenItems : []),
            ]}
          />,
        )}
      </div>
    );
  }
}

export default withStyles(s)(PopularMarksModels);



// WEBPACK FOOTER //
// ./src/desktop/components/PopularMarksModels/PopularMarksModels.js